/** Shared company-owner modal chrome — keep invoice/CRUD modals visually consistent. */

export const MODAL_CANCEL_BTN =
  "h-9 px-4 text-sm font-medium border border-slate-300 text-slate-700 bg-white rounded-md shadow-sm hover:bg-slate-100 hover:border-slate-400 transition-colors"

export const MODAL_PRIMARY_BTN =
  "h-9 px-4 text-sm font-medium bg-[#2A5C8A] text-white rounded-md shadow-sm hover:bg-[#1e4568] focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#2A5C8A]/35 disabled:opacity-50 transition-colors inline-flex items-center gap-1.5"

export const MODAL_DANGER_BTN =
  "h-9 px-4 text-sm font-medium bg-coral-red text-white rounded-md shadow-sm hover:bg-coral-red/90 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-coral-red/35 disabled:opacity-50 transition-colors inline-flex items-center gap-1.5"
export const MODAL_SECONDARY_BTN =
  "h-8 px-2.5 text-xs font-medium rounded-md text-[#2A5C8A] bg-[#E8EEF1] border border-[#C5D4DA] shadow-sm hover:bg-[#dce6ea] inline-flex items-center gap-1 transition-colors"

export const MODAL_FOOTER =
  "sticky bottom-0 z-10 -mx-5 mt-5 border-t border-slate-200/80 bg-slate-100 px-5 py-3 flex justify-end gap-2 sm:-mx-6 sm:px-6"

export const MODAL_INPUT =
  "w-full h-9 px-3 text-sm border border-slate-300 rounded-md bg-[#F8FAFB] text-slate-800 placeholder:text-slate-400 shadow-sm focus:bg-white focus:border-[#2A5C8A] focus:outline-none focus:ring-1 focus:ring-[#2A5C8A]/25"

export const MODAL_LABEL =
  "block text-[11px] font-semibold uppercase tracking-wide text-slate-600 mb-1.5"

export const MODAL_HEADER =
  "bg-[#2A5C8A] border-[#1e4568]"

export const MODAL_SHELL =
  "bg-slate-100 rounded-xl shadow-2xl border border-slate-300/70 overflow-hidden"

export const MODAL_BODY =
  "px-5 sm:px-6 py-5 max-h-[calc(100vh-180px)] overflow-y-auto custom-scrollbar bg-slate-100"

export const MODAL_OVERLAY =
  "fixed inset-0 bg-black/45 backdrop-blur-[2px] transition-opacity"
